// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/views/AICopilot/styles/chatV2.module.css */

/* ============================================
   CHAT CONTAINER
   ============================================ */

.chatV2_chatV2Container__JZ62P {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 1;
  min-height: 0;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_chatHeader__D61lN {
  padding: 12px 14px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_headerTitle__32dPk {
  font-size: 16px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_headerSubtitle__DsBj\\+ {
  font-size: 10px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_headerRight__p9KgT {
  gap: 6px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_headerButton__XGiv4 {
  padding: 0 10px;
  height: 30px;
  font-size: 12px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_messageList__sEKII {
  padding: 16px;
  gap: 16px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_suggestionCardsContainer__OaHJM {
  padding: 12px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_suggestionCardsGrid__RK8wB {
  grid-template-columns: 1fr;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_suggestionCardText__sSVf\\+ {
  font-size: 13px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_inputHelper__NXSKG {
  margin-top: 6px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_chatInputContainer__fe3Cq {
  padding: 18px 18px 22px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_inputWrapper__6RVM4 {
  padding: 8px 10px;
}

.chatV2_chatV2ContainerCompact__eFHG1 .chatV2_chatTextArea__KMXWU {
  font-size: 14px;
  line-height: 22px;
}
.chatV2_chatHeader__D61lN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}

.chatV2_headerLeft__im0tB {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chatV2_headerTitleContainer__MGs3V {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.chatV2_headerTitle__32dPk {
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  line-height: 1.2;
}

.chatV2_headerSubtitle__DsBj\\+ {
  font-size: 11px;
  color: #8c8c8c;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.chatV2_headerRight__p9KgT {
  display: flex;
  gap: 8px;
}

.chatV2_headerButton__XGiv4 {
  border-radius: 6px;
}

.chatV2_chatContent__p3DPk {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.chatV2_loadingContainer__\\+rF1c {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ============================================
   MESSAGES
   ============================================ */

.chatV2_messageList__sEKII {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  scroll-behavior: smooth;
}

.chatV2_messageWrapper__7AcLL {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  animation: chatV2_slideIn__-vaUD 0.3s ease-out;
}

.chatV2_userMessageWrapper__fsh-V {
  flex-direction: row-reverse;
}

.chatV2_avatarContainer__dUabY {
  position: relative;
  flex-shrink: 0;
}

.chatV2_aiAvatar__dLW-T {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.chatV2_userAvatar__h45qr {
  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
  box-shadow: 0 2px 8px rgba(22, 119, 255, 0.3);
}

.chatV2_completedBadge__qI\\+Bu {
  position: absolute;
  bottom: -2px;
  right: -2px;
  color: #52c41a;
  background: white;
  border-radius: 50%;
  font-size: 14px;
}

.chatV2_messageContent__3nMq5 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 70%;
}

.chatV2_userMessageContent__PouW1 {
  align-items: flex-end;
}

.chatV2_messageBubble__Yk18o {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.chatV2_messageBubble__Yk18o:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.chatV2_userBubble__JSvIk {
  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
  border: none;
  color: #ffffff;
}

.chatV2_userText__fMSEm {
  color: #ffffff;
  margin: 0;
  line-height: 1.6;
}

/* ============================================
   MARKDOWN RENDERING
   ============================================ */

.chatV2_markdown__WIE-t {
  color: #262626;
  line-height: 1.7;
  font-size: 15px;
}

.chatV2_markdown__WIE-t p {
  margin: 0 0 12px 0;
}

.chatV2_markdown__WIE-t p:last-child {
  margin-bottom: 0;
}

.chatV2_markdown__WIE-t h1,
.chatV2_markdown__WIE-t h2,
.chatV2_markdown__WIE-t h3 {
  margin: 16px 0 8px 0;
  font-weight: 600;
}

.chatV2_markdown__WIE-t ul,
.chatV2_markdown__WIE-t ol {
  margin: 8px 0;
  padding-left: 24px;
}

.chatV2_markdown__WIE-t li {
  margin: 4px 0;
}

.chatV2_inlineCode__QEdz9 {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: 'SF Mono', Monaco, monospace;
  font-size: 13px;
  color: #d63384;
}

.chatV2_codeBlock__9AyHt {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px;
  font-family: 'SF Mono', Monaco, monospace;
  font-size: 13px;
  display: block;
  overflow-x: auto;
  color: #262626;
}

.chatV2_markdownLink__lBGLG {
  color: #1677ff;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;
}

.chatV2_markdownLink__lBGLG:hover {
  border-bottom-color: #1677ff;
}

/* ============================================
   SOURCE CITATIONS
   ============================================ */

.chatV2_inlineSources__EnIaQ {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.chatV2_sourcesLabel__nRKSv {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 8px;
  font-weight: 500;
}

.chatV2_sourceChips__A\\+4MM {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chatV2_sourceChip__tAgJl {
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
  border-radius: 6px;
}

.chatV2_sourceChip__tAgJl:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* ============================================
   MESSAGE ACTIONS
   ============================================ */

.chatV2_messageFooter__wxL4k {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.chatV2_userMessageFooter__DNlek {
  flex-direction: row-reverse;
}

.chatV2_timestamp__Rkvnm {
  font-size: 11px;
  color: #8c8c8c;
}

.chatV2_messageActions__U9wW0 {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}

.chatV2_messageWrapper__7AcLL:hover .chatV2_messageActions__U9wW0 {
  opacity: 1;
}

.chatV2_actionButton__bJ674 {
  background: transparent;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
}

.chatV2_actionButton__bJ674:hover {
  background: #f5f5f5;
  border-color: #d9d9d9;
}

.chatV2_actionIcon__pXeW0 {
  font-size: 14px;
  color: #595959;
}

.chatV2_actionActive__4gLfN {
  background: #e6f4ff;
  border-color: #1677ff;
}

.chatV2_actionActive__4gLfN .chatV2_actionIcon__pXeW0 {
  color: #1677ff;
}

/* ============================================
   TYPING INDICATOR
   ============================================ */

.chatV2_typingBubble__ulQuB {
  background: #f5f5f5;
  padding: 16px 20px;
}

.chatV2_typingDots__zMe34 {
  display: flex;
  gap: 6px;
  align-items: center;
}

.chatV2_typingDot__c3qDM {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #8c8c8c;
  animation: chatV2_typingBounce__mYq3n 1.4s infinite ease-in-out;
}

.chatV2_typingDot__c3qDM:nth-child(1) {
  animation-delay: 0s;
}

.chatV2_typingDot__c3qDM:nth-child(2) {
  animation-delay: 0.2s;
}

.chatV2_typingDot__c3qDM:nth-child(3) {
  animation-delay: 0.4s;
}

.chatV2_typingLabel__-ed3R {
  font-size: 11px;
  color: #8c8c8c;
  font-style: italic;
}

/* ============================================
   CHAT INPUT
   ============================================ */

.chatV2_inputContainer__bnh-v {
  flex-shrink: 0;
}

.chatV2_chatInputContainer__fe3Cq {
  padding: 24px 24px 28px;
  border-top: 1px solid #e8e8e8;
  background: #fafafa;
}

.chatV2_inputWrapper__6RVM4 {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: #ffffff;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 10px 12px;
  transition: border-color 0.2s;
}

.chatV2_inputWrapper__6RVM4:focus-within {
  border-color: #1677ff;
}

.chatV2_inputAction__t4aLP {
  flex-shrink: 0;
  color: #595959;
}

.chatV2_chatTextArea__KMXWU {
  flex: 1 1;
  border: none;
  resize: none;
  outline: none;
  font-size: 16px;
  line-height: 24px;
  padding: 6px 10px;
  min-height: 40px;
}

.chatV2_chatTextArea__KMXWU::placeholder {
  color: #bfbfbf;
}

.chatV2_sendButton__e5maN {
  flex-shrink: 0;
  border-radius: 8px;
  height: 40px;
  padding: 0 16px;
}

.chatV2_stopButton__JZ1QY {
  flex-shrink: 0;
  border-radius: 8px;
  height: 40px;
  padding: 0 16px;
}

.chatV2_characterCount__0et8p {
  font-size: 11px;
  color: #8c8c8c;
  text-align: right;
  margin-top: 4px;
}

.chatV2_characterCountWarning__xvM9s {
  color: #faad14;
}

.chatV2_inputHelper__NXSKG {
  font-size: 11px;
  color: #8c8c8c;
  text-align: center;
  margin-top: 8px;
}

.chatV2_inputHelper__NXSKG kbd {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 11px;
}

/* ============================================
   SUGGESTIONS
   ============================================ */

.chatV2_suggestionsContainer__rJTEv {
  flex-shrink: 0;
}

.chatV2_suggestionCardsContainer__OaHJM {
  padding: 20px;
  background: #fafafa;
}

.chatV2_suggestionCardsGrid__RK8wB {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.chatV2_suggestionCard__uwdKD {
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.chatV2_suggestionCard__uwdKD:hover {
  border-color: #1677ff;
  box-shadow: 0 4px 12px rgba(22, 119, 255, 0.15);
  transform: translateY(-2px);
}

.chatV2_suggestionCardContent__AKjCh {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chatV2_suggestionCardIcon__rp-B3 {
  font-size: 20px;
  color: #1677ff;
  flex-shrink: 0;
}

.chatV2_suggestionCardText__sSVf\\+ {
  flex: 1 1;
  font-size: 14px;
  color: #262626;
  line-height: 1.5;
}

.chatV2_suggestionCardTag__5Y6m0 {
  font-size: 11px;
}

/* ============================================
   CONVERSATION SIDEBAR
   ============================================ */

.chatV2_conversationSearch__IVfKs {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.chatV2_conversationList__\\+AsFy {
  overflow-y: auto;
  height: calc(100vh - 200px);
}

.chatV2_conversationGroup__7WYk3 {
  margin-bottom: 24px;
}

.chatV2_groupTitle__PLzOo {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  text-transform: uppercase;
  padding: 8px 16px;
  letter-spacing: 0.5px;
}

.chatV2_conversationItem__8I9iz {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s;
  border-left: 3px solid transparent;
}

.chatV2_conversationItem__8I9iz:hover {
  background: #f5f5f5;
}

.chatV2_conversationItemActive__MH2yi {
  background: #e6f4ff;
  border-left-color: #1677ff;
}

.chatV2_conversationContent__I28ok {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.chatV2_conversationIcon__RtL13 {
  font-size: 16px;
  color: #8c8c8c;
}

.chatV2_conversationInfo__uL\\+w8 {
  flex: 1 1;
  min-width: 0;
}

.chatV2_conversationTitle__JN\\+nh {
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatV2_conversationMeta__IbmEj {
  font-size: 11px;
  color: #8c8c8c;
  margin-top: 2px;
}

.chatV2_conversationActions__pqLwZ {
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #8c8c8c;
  transition: color 0.2s;
  opacity: 0;
}

.chatV2_conversationItem__8I9iz:hover .chatV2_conversationActions__pqLwZ {
  opacity: 1;
}

.chatV2_conversationActions__pqLwZ:hover {
  color: #262626;
}

/* ============================================
   SOURCE DETAIL MODAL
   ============================================ */

.chatV2_sourceModalHeader__IgSK4 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chatV2_healthBadge__pVYZY {
  font-weight: 600;
}

.chatV2_sourceModalContent__zMbVW {
  max-height: 600px;
  overflow-y: auto;
}

.chatV2_sourceExcerpt__YaYF3 {
  margin-top: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
}

.chatV2_sourceExcerpt__YaYF3 h4 {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #595959;
}

.chatV2_sourceExcerpt__YaYF3 p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #262626;
}

.chatV2_sourceDataset__daES1 {
  margin-top: 16px;
}

.chatV2_sourceDataset__daES1 h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
}

.chatV2_columnList__90YRx {
  margin-top: 12px;
}

.chatV2_columnList__90YRx h5 {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 500;
  color: #595959;
}

.chatV2_columnTags__ihF4r {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* ============================================
   ANIMATIONS
   ============================================ */

@keyframes chatV2_slideIn__-vaUD {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes chatV2_typingBounce__mYq3n {
  0%,
  60%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-8px);
  }
}

/* ============================================
   SCROLLBAR STYLING
   ============================================ */

.chatV2_messageList__sEKII::-webkit-scrollbar,
.chatV2_conversationList__\\+AsFy::-webkit-scrollbar {
  width: 6px;
}

.chatV2_messageList__sEKII::-webkit-scrollbar-track,
.chatV2_conversationList__\\+AsFy::-webkit-scrollbar-track {
  background: transparent;
}

.chatV2_messageList__sEKII::-webkit-scrollbar-thumb,
.chatV2_conversationList__\\+AsFy::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

.chatV2_messageList__sEKII::-webkit-scrollbar-thumb:hover,
.chatV2_conversationList__\\+AsFy::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

/* ============================================
   MOBILE RESPONSIVE STYLES
   ============================================ */

/* Mobile Breakpoints */
@media (max-width: 768px) {
  /* Chat Container */
  .chatV2_chatV2Container__JZ62P {
    height: calc(100vh - 60px);
    border-radius: 0;
  }

  /* Message Bubbles */
  .chatV2_messageBubble__Yk18o {
    max-width: 85%;
    font-size: 15px;
    padding: 12px 14px;
  }

  /* Avatars */
  .chatV2_avatarContainer__dUabY {
    display: none; /* Hide avatars on very small screens */
  }

  /* Input Area */
  .chatV2_chatInputContainer__fe3Cq {
    padding: 12px;
    border-radius: 0;
  }

  .chatV2_chatTextArea__KMXWU {
    font-size: 16px; /* Prevent zoom on iOS */
  }

  /* Suggestions */
  .chatV2_suggestionCardsGrid__RK8wB {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  /* Source Chips */
  .chatV2_sourceChips__A\\+4MM {
    flex-wrap: wrap;
  }

  .chatV2_sourceChip__tAgJl {
    font-size: 11px;
    padding: 2px 6px;
  }

  /* Message Actions */
  .chatV2_messageActions__U9wW0 {
    flex-wrap: wrap;
    gap: 4px;
  }

  .chatV2_actionButton__bJ674 {
    min-width: 32px;
    height: 32px;
  }

  /* Conversation Sidebar */
  .chatV2_conversationDrawer__K116b {
    width: 100% !important;
  }
}

/* Tablet */
@media (min-width: 769px) and (max-width: 1024px) {
  .chatV2_messageBubble__Yk18o {
    max-width: 75%;
  }

  .chatV2_suggestionCardsGrid__RK8wB {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Touch-specific styles */
@media (hover: none) and (pointer: coarse) {
  /* Larger touch targets */
  .chatV2_actionButton__bJ674 {
    min-width: 44px;
    height: 44px;
  }

  .chatV2_sourceChip__tAgJl {
    min-height: 32px;
    padding: 6px 12px;
  }

  /* Always show actions on touch devices */
  .chatV2_messageActions__U9wW0 {
    opacity: 1;
  }

  /* Prevent double-tap zoom */
  .chatV2_messageBubble__Yk18o {
    touch-action: manipulation;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/AICopilot/styles/chatV2.module.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8CAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+DAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;IAGE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;iDAEiD;;AAEjD;;EAEE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD,uBAAuB;AACvB;EACE,mBAAmB;EACnB;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,aAAa,EAAE,uCAAuC;EACxD;;EAEA,eAAe;EACf;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA,gBAAgB;EAChB;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,yCAAyC;EACzC;IACE,UAAU;EACZ;;EAEA,4BAA4B;EAC5B;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* src/views/AICopilot/styles/chatV2.module.css */\n\n/* ============================================\n   CHAT CONTAINER\n   ============================================ */\n\n.chatV2Container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  flex: 1;\n  min-height: 0;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.chatV2ContainerCompact .chatHeader {\n  padding: 12px 14px;\n}\n\n.chatV2ContainerCompact .headerTitle {\n  font-size: 16px;\n}\n\n.chatV2ContainerCompact .headerSubtitle {\n  font-size: 10px;\n}\n\n.chatV2ContainerCompact .headerRight {\n  gap: 6px;\n}\n\n.chatV2ContainerCompact .headerButton {\n  padding: 0 10px;\n  height: 30px;\n  font-size: 12px;\n}\n\n.chatV2ContainerCompact .messageList {\n  padding: 16px;\n  gap: 16px;\n}\n\n.chatV2ContainerCompact .suggestionCardsContainer {\n  padding: 12px;\n}\n\n.chatV2ContainerCompact .suggestionCardsGrid {\n  grid-template-columns: 1fr;\n}\n\n.chatV2ContainerCompact .suggestionCardText {\n  font-size: 13px;\n}\n\n.chatV2ContainerCompact .inputHelper {\n  margin-top: 6px;\n}\n\n.chatV2ContainerCompact .chatInputContainer {\n  padding: 18px 18px 22px;\n}\n\n.chatV2ContainerCompact .inputWrapper {\n  padding: 8px 10px;\n}\n\n.chatV2ContainerCompact .chatTextArea {\n  font-size: 14px;\n  line-height: 22px;\n}\n.chatHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e8e8e8;\n  background: #fafafa;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.headerTitleContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.headerTitle {\n  font-size: 18px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.headerSubtitle {\n  font-size: 11px;\n  color: #8c8c8c;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n}\n\n.headerRight {\n  display: flex;\n  gap: 8px;\n}\n\n.headerButton {\n  border-radius: 6px;\n}\n\n.chatContent {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.loadingContainer {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ============================================\n   MESSAGES\n   ============================================ */\n\n.messageList {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  scroll-behavior: smooth;\n}\n\n.messageWrapper {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  animation: slideIn 0.3s ease-out;\n}\n\n.userMessageWrapper {\n  flex-direction: row-reverse;\n}\n\n.avatarContainer {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.aiAvatar {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.userAvatar {\n  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);\n  box-shadow: 0 2px 8px rgba(22, 119, 255, 0.3);\n}\n\n.completedBadge {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  color: #52c41a;\n  background: white;\n  border-radius: 50%;\n  font-size: 14px;\n}\n\n.messageContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 70%;\n}\n\n.userMessageContent {\n  align-items: flex-end;\n}\n\n.messageBubble {\n  background: #ffffff;\n  border: 1px solid #e8e8e8;\n  border-radius: 12px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.messageBubble:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.userBubble {\n  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);\n  border: none;\n  color: #ffffff;\n}\n\n.userText {\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* ============================================\n   MARKDOWN RENDERING\n   ============================================ */\n\n.markdown {\n  color: #262626;\n  line-height: 1.7;\n  font-size: 15px;\n}\n\n.markdown p {\n  margin: 0 0 12px 0;\n}\n\n.markdown p:last-child {\n  margin-bottom: 0;\n}\n\n.markdown h1,\n.markdown h2,\n.markdown h3 {\n  margin: 16px 0 8px 0;\n  font-weight: 600;\n}\n\n.markdown ul,\n.markdown ol {\n  margin: 8px 0;\n  padding-left: 24px;\n}\n\n.markdown li {\n  margin: 4px 0;\n}\n\n.inlineCode {\n  background: #f5f5f5;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-family: 'SF Mono', Monaco, monospace;\n  font-size: 13px;\n  color: #d63384;\n}\n\n.codeBlock {\n  background: #f5f5f5;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  padding: 12px;\n  font-family: 'SF Mono', Monaco, monospace;\n  font-size: 13px;\n  display: block;\n  overflow-x: auto;\n  color: #262626;\n}\n\n.markdownLink {\n  color: #1677ff;\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: border-color 0.2s;\n}\n\n.markdownLink:hover {\n  border-bottom-color: #1677ff;\n}\n\n/* ============================================\n   SOURCE CITATIONS\n   ============================================ */\n\n.inlineSources {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.sourcesLabel {\n  font-size: 12px;\n  color: #8c8c8c;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.sourceChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.sourceChip {\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 12px;\n  border-radius: 6px;\n}\n\n.sourceChip:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* ============================================\n   MESSAGE ACTIONS\n   ============================================ */\n\n.messageFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.userMessageFooter {\n  flex-direction: row-reverse;\n}\n\n.timestamp {\n  font-size: 11px;\n  color: #8c8c8c;\n}\n\n.messageActions {\n  display: flex;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.messageWrapper:hover .messageActions {\n  opacity: 1;\n}\n\n.actionButton {\n  background: transparent;\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  padding: 4px 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n}\n\n.actionButton:hover {\n  background: #f5f5f5;\n  border-color: #d9d9d9;\n}\n\n.actionIcon {\n  font-size: 14px;\n  color: #595959;\n}\n\n.actionActive {\n  background: #e6f4ff;\n  border-color: #1677ff;\n}\n\n.actionActive .actionIcon {\n  color: #1677ff;\n}\n\n/* ============================================\n   TYPING INDICATOR\n   ============================================ */\n\n.typingBubble {\n  background: #f5f5f5;\n  padding: 16px 20px;\n}\n\n.typingDots {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.typingDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #8c8c8c;\n  animation: typingBounce 1.4s infinite ease-in-out;\n}\n\n.typingDot:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.typingDot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typingDot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n.typingLabel {\n  font-size: 11px;\n  color: #8c8c8c;\n  font-style: italic;\n}\n\n/* ============================================\n   CHAT INPUT\n   ============================================ */\n\n.inputContainer {\n  flex-shrink: 0;\n}\n\n.chatInputContainer {\n  padding: 24px 24px 28px;\n  border-top: 1px solid #e8e8e8;\n  background: #fafafa;\n}\n\n.inputWrapper {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  background: #ffffff;\n  border: 2px solid #e8e8e8;\n  border-radius: 12px;\n  padding: 10px 12px;\n  transition: border-color 0.2s;\n}\n\n.inputWrapper:focus-within {\n  border-color: #1677ff;\n}\n\n.inputAction {\n  flex-shrink: 0;\n  color: #595959;\n}\n\n.chatTextArea {\n  flex: 1;\n  border: none;\n  resize: none;\n  outline: none;\n  font-size: 16px;\n  line-height: 24px;\n  padding: 6px 10px;\n  min-height: 40px;\n}\n\n.chatTextArea::placeholder {\n  color: #bfbfbf;\n}\n\n.sendButton {\n  flex-shrink: 0;\n  border-radius: 8px;\n  height: 40px;\n  padding: 0 16px;\n}\n\n.stopButton {\n  flex-shrink: 0;\n  border-radius: 8px;\n  height: 40px;\n  padding: 0 16px;\n}\n\n.characterCount {\n  font-size: 11px;\n  color: #8c8c8c;\n  text-align: right;\n  margin-top: 4px;\n}\n\n.characterCountWarning {\n  color: #faad14;\n}\n\n.inputHelper {\n  font-size: 11px;\n  color: #8c8c8c;\n  text-align: center;\n  margin-top: 8px;\n}\n\n.inputHelper kbd {\n  background: #f5f5f5;\n  border: 1px solid #e8e8e8;\n  border-radius: 3px;\n  padding: 2px 6px;\n  font-family: monospace;\n  font-size: 11px;\n}\n\n/* ============================================\n   SUGGESTIONS\n   ============================================ */\n\n.suggestionsContainer {\n  flex-shrink: 0;\n}\n\n.suggestionCardsContainer {\n  padding: 20px;\n  background: #fafafa;\n}\n\n.suggestionCardsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 12px;\n}\n\n.suggestionCard {\n  border-radius: 10px;\n  border: 1px solid #e8e8e8;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n}\n\n.suggestionCard:hover {\n  border-color: #1677ff;\n  box-shadow: 0 4px 12px rgba(22, 119, 255, 0.15);\n  transform: translateY(-2px);\n}\n\n.suggestionCardContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.suggestionCardIcon {\n  font-size: 20px;\n  color: #1677ff;\n  flex-shrink: 0;\n}\n\n.suggestionCardText {\n  flex: 1;\n  font-size: 14px;\n  color: #262626;\n  line-height: 1.5;\n}\n\n.suggestionCardTag {\n  font-size: 11px;\n}\n\n/* ============================================\n   CONVERSATION SIDEBAR\n   ============================================ */\n\n.conversationSearch {\n  padding: 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.conversationList {\n  overflow-y: auto;\n  height: calc(100vh - 200px);\n}\n\n.conversationGroup {\n  margin-bottom: 24px;\n}\n\n.groupTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n  text-transform: uppercase;\n  padding: 8px 16px;\n  letter-spacing: 0.5px;\n}\n\n.conversationItem {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background 0.2s;\n  border-left: 3px solid transparent;\n}\n\n.conversationItem:hover {\n  background: #f5f5f5;\n}\n\n.conversationItemActive {\n  background: #e6f4ff;\n  border-left-color: #1677ff;\n}\n\n.conversationContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.conversationIcon {\n  font-size: 16px;\n  color: #8c8c8c;\n}\n\n.conversationInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.conversationTitle {\n  font-size: 14px;\n  font-weight: 500;\n  color: #262626;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.conversationMeta {\n  font-size: 11px;\n  color: #8c8c8c;\n  margin-top: 2px;\n}\n\n.conversationActions {\n  background: transparent;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: #8c8c8c;\n  transition: color 0.2s;\n  opacity: 0;\n}\n\n.conversationItem:hover .conversationActions {\n  opacity: 1;\n}\n\n.conversationActions:hover {\n  color: #262626;\n}\n\n/* ============================================\n   SOURCE DETAIL MODAL\n   ============================================ */\n\n.sourceModalHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.healthBadge {\n  font-weight: 600;\n}\n\n.sourceModalContent {\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.sourceExcerpt {\n  margin-top: 16px;\n  padding: 12px;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.sourceExcerpt h4 {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #595959;\n}\n\n.sourceExcerpt p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #262626;\n}\n\n.sourceDataset {\n  margin-top: 16px;\n}\n\n.sourceDataset h4 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.columnList {\n  margin-top: 12px;\n}\n\n.columnList h5 {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #595959;\n}\n\n.columnTags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* ============================================\n   ANIMATIONS\n   ============================================ */\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes typingBounce {\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n  }\n  30% {\n    transform: translateY(-8px);\n  }\n}\n\n/* ============================================\n   SCROLLBAR STYLING\n   ============================================ */\n\n.messageList::-webkit-scrollbar,\n.conversationList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.messageList::-webkit-scrollbar-track,\n.conversationList::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.messageList::-webkit-scrollbar-thumb,\n.conversationList::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 3px;\n}\n\n.messageList::-webkit-scrollbar-thumb:hover,\n.conversationList::-webkit-scrollbar-thumb:hover {\n  background: #bfbfbf;\n}\n\n/* ============================================\n   MOBILE RESPONSIVE STYLES\n   ============================================ */\n\n/* Mobile Breakpoints */\n@media (max-width: 768px) {\n  /* Chat Container */\n  .chatV2Container {\n    height: calc(100vh - 60px);\n    border-radius: 0;\n  }\n\n  /* Message Bubbles */\n  .messageBubble {\n    max-width: 85%;\n    font-size: 15px;\n    padding: 12px 14px;\n  }\n\n  /* Avatars */\n  .avatarContainer {\n    display: none; /* Hide avatars on very small screens */\n  }\n\n  /* Input Area */\n  .chatInputContainer {\n    padding: 12px;\n    border-radius: 0;\n  }\n\n  .chatTextArea {\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n\n  /* Suggestions */\n  .suggestionCardsGrid {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  /* Source Chips */\n  .sourceChips {\n    flex-wrap: wrap;\n  }\n\n  .sourceChip {\n    font-size: 11px;\n    padding: 2px 6px;\n  }\n\n  /* Message Actions */\n  .messageActions {\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .actionButton {\n    min-width: 32px;\n    height: 32px;\n  }\n\n  /* Conversation Sidebar */\n  .conversationDrawer {\n    width: 100% !important;\n  }\n}\n\n/* Tablet */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .messageBubble {\n    max-width: 75%;\n  }\n\n  .suggestionCardsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Touch-specific styles */\n@media (hover: none) and (pointer: coarse) {\n  /* Larger touch targets */\n  .actionButton {\n    min-width: 44px;\n    height: 44px;\n  }\n\n  .sourceChip {\n    min-height: 32px;\n    padding: 6px 12px;\n  }\n\n  /* Always show actions on touch devices */\n  .messageActions {\n    opacity: 1;\n  }\n\n  /* Prevent double-tap zoom */\n  .messageBubble {\n    touch-action: manipulation;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatV2Container": `chatV2_chatV2Container__JZ62P`,
	"chatV2ContainerCompact": `chatV2_chatV2ContainerCompact__eFHG1`,
	"chatHeader": `chatV2_chatHeader__D61lN`,
	"headerTitle": `chatV2_headerTitle__32dPk`,
	"headerSubtitle": `chatV2_headerSubtitle__DsBj+`,
	"headerRight": `chatV2_headerRight__p9KgT`,
	"headerButton": `chatV2_headerButton__XGiv4`,
	"messageList": `chatV2_messageList__sEKII`,
	"suggestionCardsContainer": `chatV2_suggestionCardsContainer__OaHJM`,
	"suggestionCardsGrid": `chatV2_suggestionCardsGrid__RK8wB`,
	"suggestionCardText": `chatV2_suggestionCardText__sSVf+`,
	"inputHelper": `chatV2_inputHelper__NXSKG`,
	"chatInputContainer": `chatV2_chatInputContainer__fe3Cq`,
	"inputWrapper": `chatV2_inputWrapper__6RVM4`,
	"chatTextArea": `chatV2_chatTextArea__KMXWU`,
	"headerLeft": `chatV2_headerLeft__im0tB`,
	"headerTitleContainer": `chatV2_headerTitleContainer__MGs3V`,
	"chatContent": `chatV2_chatContent__p3DPk`,
	"loadingContainer": `chatV2_loadingContainer__+rF1c`,
	"messageWrapper": `chatV2_messageWrapper__7AcLL`,
	"slideIn": `chatV2_slideIn__-vaUD`,
	"userMessageWrapper": `chatV2_userMessageWrapper__fsh-V`,
	"avatarContainer": `chatV2_avatarContainer__dUabY`,
	"aiAvatar": `chatV2_aiAvatar__dLW-T`,
	"userAvatar": `chatV2_userAvatar__h45qr`,
	"completedBadge": `chatV2_completedBadge__qI+Bu`,
	"messageContent": `chatV2_messageContent__3nMq5`,
	"userMessageContent": `chatV2_userMessageContent__PouW1`,
	"messageBubble": `chatV2_messageBubble__Yk18o`,
	"userBubble": `chatV2_userBubble__JSvIk`,
	"userText": `chatV2_userText__fMSEm`,
	"markdown": `chatV2_markdown__WIE-t`,
	"inlineCode": `chatV2_inlineCode__QEdz9`,
	"codeBlock": `chatV2_codeBlock__9AyHt`,
	"markdownLink": `chatV2_markdownLink__lBGLG`,
	"inlineSources": `chatV2_inlineSources__EnIaQ`,
	"sourcesLabel": `chatV2_sourcesLabel__nRKSv`,
	"sourceChips": `chatV2_sourceChips__A+4MM`,
	"sourceChip": `chatV2_sourceChip__tAgJl`,
	"messageFooter": `chatV2_messageFooter__wxL4k`,
	"userMessageFooter": `chatV2_userMessageFooter__DNlek`,
	"timestamp": `chatV2_timestamp__Rkvnm`,
	"messageActions": `chatV2_messageActions__U9wW0`,
	"actionButton": `chatV2_actionButton__bJ674`,
	"actionIcon": `chatV2_actionIcon__pXeW0`,
	"actionActive": `chatV2_actionActive__4gLfN`,
	"typingBubble": `chatV2_typingBubble__ulQuB`,
	"typingDots": `chatV2_typingDots__zMe34`,
	"typingDot": `chatV2_typingDot__c3qDM`,
	"typingBounce": `chatV2_typingBounce__mYq3n`,
	"typingLabel": `chatV2_typingLabel__-ed3R`,
	"inputContainer": `chatV2_inputContainer__bnh-v`,
	"inputAction": `chatV2_inputAction__t4aLP`,
	"sendButton": `chatV2_sendButton__e5maN`,
	"stopButton": `chatV2_stopButton__JZ1QY`,
	"characterCount": `chatV2_characterCount__0et8p`,
	"characterCountWarning": `chatV2_characterCountWarning__xvM9s`,
	"suggestionsContainer": `chatV2_suggestionsContainer__rJTEv`,
	"suggestionCard": `chatV2_suggestionCard__uwdKD`,
	"suggestionCardContent": `chatV2_suggestionCardContent__AKjCh`,
	"suggestionCardIcon": `chatV2_suggestionCardIcon__rp-B3`,
	"suggestionCardTag": `chatV2_suggestionCardTag__5Y6m0`,
	"conversationSearch": `chatV2_conversationSearch__IVfKs`,
	"conversationList": `chatV2_conversationList__+AsFy`,
	"conversationGroup": `chatV2_conversationGroup__7WYk3`,
	"groupTitle": `chatV2_groupTitle__PLzOo`,
	"conversationItem": `chatV2_conversationItem__8I9iz`,
	"conversationItemActive": `chatV2_conversationItemActive__MH2yi`,
	"conversationContent": `chatV2_conversationContent__I28ok`,
	"conversationIcon": `chatV2_conversationIcon__RtL13`,
	"conversationInfo": `chatV2_conversationInfo__uL+w8`,
	"conversationTitle": `chatV2_conversationTitle__JN+nh`,
	"conversationMeta": `chatV2_conversationMeta__IbmEj`,
	"conversationActions": `chatV2_conversationActions__pqLwZ`,
	"sourceModalHeader": `chatV2_sourceModalHeader__IgSK4`,
	"healthBadge": `chatV2_healthBadge__pVYZY`,
	"sourceModalContent": `chatV2_sourceModalContent__zMbVW`,
	"sourceExcerpt": `chatV2_sourceExcerpt__YaYF3`,
	"sourceDataset": `chatV2_sourceDataset__daES1`,
	"columnList": `chatV2_columnList__90YRx`,
	"columnTags": `chatV2_columnTags__ihF4r`,
	"conversationDrawer": `chatV2_conversationDrawer__K116b`
};
export default ___CSS_LOADER_EXPORT___;
